export const defaultAttachmentAdaptiveCardStyles = {
  borderStyle: "solid",
  borderColor: "rgb(230, 230, 230)",
  borderWidth: "1px"
};